import {
    Col,
    Row,
} from 'reactstrap';

import ChipIcon from './ChipIcon';

const AiSummary = ({
    t,
    summary,
    ratingsFound,
}) => (
    <div className="overview-esg-rating__summary">
        <div className="d-flex align-items-center gap-2 mb-3">
            <h6 className="overview-esg-rating__block-title mb-0">
                {t('AI Summary')}
            </h6>
            <ChipIcon />
        </div>

        <Row className="g-3 align-items-center">
            <Col xs="12" xl="5">
                <p className="overview-esg-rating__summary-text mb-0">
                    {summary}
                </p>
            </Col>

            <Col xs="12" xl="7">
                <div className="overview-esg-rating__panel">
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="overview-esg-rating__eyebrow">
                            {t('ESG Ratings Found')}
                        </span>
                        <ChipIcon />
                    </div>

                    <div className="overview-esg-rating__found-count mb-2">
                        <span className="overview-esg-rating__found-number">
                            {ratingsFound?.count}
                        </span>
                        <span className="overview-esg-rating__found-label">
                            {t('sources')}
                        </span>
                    </div>

                    <div className="overview-esg-rating__source-chips">
                        {(ratingsFound?.sources || []).map((source) => (
                            <div
                                key={source.key}
                                className="overview-esg-rating__source-chip"
                            >
                                <span>{source.name}</span>
                                <strong>{source.value}</strong>
                            </div>
                        ))}
                    </div>
                </div>
            </Col>
        </Row>
    </div>
);

export default AiSummary;
